<template>
  <el-dialog id="dialogServerReserve" title="Резервный медиа-сервер" :visible="visible" @close="onClose">
    <el-form id="formServerReserve" label-position="right" label-width="150px">
      <el-form-item label="Кластер">
        <el-select
          style="width: 100%"
          size="small"
          placeholder="Выберите кластер"
          v-model="massClusterAlias"
          @change="onChange"
        >
          <el-option
            v-for="cluster in massClusters"
            :key="cluster"
            :label="cluster"
            :value="cluster"
          >{{ cluster }}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Медиа-сервер">
        <reserve-server-select
          v-model="newIdServer"
          :current-id-server="idServer"
          :current-mass-cluster-alias="massClusterAlias"
        />
      </el-form-item>
      <el-form-item label="Принудительно">
        <el-switch
          v-model="force"
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button id="closeServerReserve" @click="onClose">Отменить</el-button>
      <el-button id="submitServerReserve" :loading="loading" type="primary" @click="onSave">{{ confirmButtonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ReserveServerSelect from "@/components/Server/feature/ReserveServerSelect";
import { mapState } from "vuex";

export default {
  name: "ReserveServerDialog",
  components: { ReserveServerSelect },
  props: {
    idServer: {
      type: Number,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    confirmButtonText: {
      type: String,
      default: "Сохранить",
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      newIdServer: null,
      massClusters: [],
      massClusterAlias: '',
      force: 0,
    };
  },
  computed: {
    ...mapState("server", {
      server: (state) => state.server,
    }),
  },
  watch: {
    idServer(idServer) {
      this.newIdServer = idServer;
    },
    server(server) {
      this.massClusters = (server.is_reserve === 0)
        ? ["single", "massive"]
        : ["massive", "production"];

      if (this.massClusters.length === 1) this.massClusterAlias = this.massClusters[0];
    },
  },
  methods: {
    onChange() {
      this.newIdServer = null;
    },
    onSave() {
      this.$emit("save", this.newIdServer, this.force);
    },
    onClose() {
      this.$emit("close");
    },
  },
}
</script>
